import React from 'react';
import { Group } from '@landr/maestro';
import { AttributeGroups } from 'types/attributes';
import { AttributesBadge } from 'components/AttributesBadge/AttributesBadge';

const Attributes: React.FC<{
    attributes?: AttributeGroups;
    isMobile?: boolean;
}> = ({ attributes }) => {
    if (!attributes) {
        return null;
    }

    return (
        <Group.Item maxWidth="80%" alignSelf="center">
            <Group gutter="xs">
                <AttributesBadge
                    attributes={attributes}
                    options={{
                        variant: 'default',
                        size: 'sm',
                    }}
                />
            </Group>
        </Group.Item>
    );
};

Attributes.displayName = 'PageHeader.Attributes';

export default Attributes;
